import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
/**
 * Create Axios instance pre-configured with cache (using axios-cache-adapter).
 * @param maxAgeMin Cache max-age in minutes.
 * @returns Pre-configured Axios instance
 */

export const createAxiosWithCache = maxAgeMin => {
  // Create `axios-cache-adapter` instance
  const {
    adapter
  } = setupCache({
    maxAge: maxAgeMin * 60 * 1000,
    exclude: {
      query: false
    } // Cache URLs with query parameters

  }); // Return `axios` instance passing the newly created `cache.adapter`

  return axios.create({
    adapter
  });
};
//# sourceMappingURL=createAxiosWithCache.js.map